export function getPage() {
	return decodeURIComponent(window.location.pathname.slice(1).split("/")[0])
}